import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useApi from "../../../../services/auth/useApi";

import { useRecoilState } from "recoil";
import { tokenState } from "../../../../recoil/auth/tokenState";

import { AppPathComposer, ApiPathComposer } from "../../../../api/genPath";

import profileDefaultIcon from "../../../../assets/Settings/profile-default-icon.png";
import { Flex } from "@chakra-ui/react";
import styles from "./Account.module.css";
import { UserProfile } from "../../../../types/account/type";

interface MyProfileProps {
  onDelete: () => void;
  loginData: UserProfile;
}

const MyProfile = ({ onDelete, loginData }: MyProfileProps) => {
  const [token, setToken] = useRecoilState(tokenState);
  const api = useApi();
  const navigate = useNavigate();

  // NOTE: 인증 상태를 담당하는 HOC가 하나 있어야 하지 않나 의견
  // - WHY? 인증 redirect를 여기저기서 처리하고 있음
  // - 일단 logic 자체는 ASIS대로 유지
  useEffect(() => {
    if (token.mAccessToken === null) {
      if (document.startViewTransition) {
        document.startViewTransition(() => {
          navigate(AppPathComposer.main);
        });
      } else {
        navigate(AppPathComposer.main);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  function handleLogoutClick() {
    // TODO: 에러 처리

    // 요청을 보내고 바로 client에서는 응답을 기다리지 않고 바로 로그아웃 처리
    api.post(ApiPathComposer.logout);

    setToken({
      mAccessToken: null,
      mRefreshToken: null,
    });

    navigate(AppPathComposer.login);
  }

  const toggleDeleteAccountPopup = () => {
    onDelete();
  };

  return (
    <div className={styles.profile__total__area}>
      <div className={styles.profile__area}>
        <img
          src={loginData.photo}
          alt="profile"
          onError={(e) => {
            const target = e.currentTarget;
            target.onerror = null;
            target.src = profileDefaultIcon;
          }}
        />
        <div className={styles.profile__text__area}>
          <span className={styles.profile__nickname}>
            {loginData.givenName} {loginData.familyName}
          </span>
          <span className={styles.profile__email}>{loginData.email}</span>
        </div>
      </div>

      <Flex
        gap={1.5}
        justifyContent={"flex-end"}
      >
        <button
          className={styles.logout__button}
          onClick={handleLogoutClick}
        >
          Logout
        </button>
        <button
          className={styles.delete__button}
          onClick={toggleDeleteAccountPopup}
        >
          Delete account
        </button>
      </Flex>
    </div>
  );
};

export default MyProfile;
